<template>
  <div class="container-fluid">
    <Header></Header>
    <div
      class="mx-auto mt-1 content-outer-container"
      :class="{ 'content-dashboard': $store.state.isDashboard }"
    >
      <div class="mx-auto content-inner-container">
        <div class="header-wrapper">
          <div @click="goback()" class="button-back">
            <img
              class="button-arrow-back"
              src="@/assets/images/userlevel/arrow_back.svg"
              alt="arrow_back"
            />
          </div>
          <div class="title">
            {{ handleTitle() }}
          </div>
        </div>
        <div class="history-wrapper">
          <a-table
            :row-key="record => record.DisplayVersion"
            :columns="columnsHistory"
            :data-source="historyData"
            :pagination="{ hideOnSinglePage: true }"
          >
            <template slot="status" slot-scope="text">
              <span class="status">
                <a-tag
                  :color="statusColor(text)"
                  style="border-radius: 20px; padding: 4px 16px"
                  :style="{
                    'background-color': text == 0 ? '#fefefe' : '',
                    'border-color': text == 0 ? '#C9C9C9' : '',
                    color: text == 0 ? '#4A4A4A' : '',
                  }"
                >
                  <a-badge :color="statusColor(text)" />
                  <span style="font-weight: bold">{{ statusName(text) }}</span>
                </a-tag>
              </span>
            </template>
            <template slot="date" slot-scope="text">
              <span> {{ dateformat(text) }} </span>
            </template>
            <template slot="action" slot-scope="record">
              <a-tooltip :title="lbl['view_title']">
                <div class="action-icon" @click="view(record)">
                  <a-icon type="eye" />
                </div>
              </a-tooltip>
            </template>
          </a-table>
        </div>
      </div>
    </div>
    <PDPAModal
      v-if="showPDPAModal"
      :visible="showPDPAModal"
      :version-list="versionList"
      :data="PDPAdata"
      :history="historyData"
      @close="showPDPAModal = false"
    />
  </div>
</template>

<script>
import Mixin from '@/mixin/Mixin'
import Account from '@/helper/AccountHelper.js'
import Header from '@/components/Layout/Header'
import BzbsConsent from '@/core/PDPA/BzbsConsent'
import Locale from '@/helper/locale.js'
import moment from 'moment'
import _ from 'lodash'
import PDPAModal from '@/module/Settings/components/PDPAModal'
export default {
  name: 'PdpaUpload',
  mixins: [Mixin],
  components: {
    Header,
    PDPAModal,
  },
  data() {
    return {
      activeTab: 1,
      columnsHistory: [
        {
          title: 'Status',
          key: 'history_pdpa_column_status',
          dataIndex: 'Status',
          width: 200,
          align: 'left',
          filters: [
            { text: 'Create', value: '2' },
            { text: 'Active', value: '1' },
            { text: 'Inactive', value: '0' },
          ],
          onFilter: (value, record) =>
            record.Status && record.Status.includes(value),
          scopedSlots: { customRender: 'status' },
        },
        {
          title: 'Version Number',
          key: 'history_pdpa_column_version',
          dataIndex: 'DisplayVersion',
          align: 'left',
          width: 200,
          sorter: (a, b) => a.DisplayVersion - b.DisplayVersion,
          scopedSlots: { customRender: 'version' },
        },
        {
          title: 'Create Date',
          key: 'history_pdpa_column_create_date',
          dataIndex: 'CreatedDate',
          align: 'center',
          sorter: (a, b) => moment(a.CreatedDate) - moment(b.CreatedDate),
          scopedSlots: { customRender: 'date' },
        },
        {
          title: 'Publish Date',
          key: 'history_pdpa_column_publish_date',
          dataIndex: 'PublishDate',
          align: 'center',
          sorter: (a, b) => moment(a.PublishDate) - moment(b.PublishDate),
          scopedSlots: { customRender: 'date' },
        },
        {
          title: '',
          key: 'operation',
          align: 'center',
          width: 50,
          scopedSlots: { customRender: 'action' },
        },
      ],
      historyData: [],
      versionList: [],
      content: '',
      showPDPAModal: false,
      PDPAdata: null,
      CurrentVersion: null,
      currentLocale: Locale.getLocaleShort(),
    }
  },

  created() {
    this.handleFooter(true)
    this.filters = [
      { text: this.lbl['pdpa_status_1'], value: '2' },
      { text: this.lbl['pdpa_status_2'], value: '1' },
      { text: this.lbl['pdpa_status_3'], value: '0' },
    ]
    this.setLocale()
    Account.bzbsAnalyticTracking(
      'privacy_conditions_history_page',
      'privacy_conditions_history',
      'view_privacy_conditions_history_' + this.$route.params.type,
      'on view',
    )
  },
  mounted() {
    this.getHistory()
  },
  methods: {
    setLocale() {
      _.forEach(this.columnsHistory, column => {
        column.title = this.lbl[column.key]
      })
    },
    getHistory() {
      return new Promise(resolve => {
        BzbsConsent.getConsentHistory(this.$route.params.type)
          .then(res => {
            if (res.data.success) {
              this.CurrentVersion = res.data.data.CurrentVersion
              if (res.data.data.Histories.length) {
                this.historyData = res.data.data.Histories
                this.getVersionList()
                if (this.historyData.length) {
                  this.historyData[this.historyData.length - 1].CreatedDate =
                    null
                  this.historyData[this.historyData.length - 1].PublishDate =
                    null
                }
              }
            }
            resolve(res.data.data)
          })
          .catch(error => {
            resolve(error)
          })
      })
    },
    getVersionList() {
      this.versionList = this.historyData.map(item => {
        return {
          value: item.DisplayVersion,
          update: item.PublishDate,
        }
      })
    },
    handleTitle() {
      switch (this.$route.params.type) {
        case 'TermAndCondition':
          return this.lbl['term_and_condition_history_title']

        case 'PrivacyPolicy':
          return this.lbl['privacy_policy_history_title']

        case 'MarketingMessage':
          return this.lbl['marketing_history_title']

        default:
          return this.lbl['term_and_condition_history_title']
      }
    },
    statusColor(status) {
      if (status == '1') {
        return 'green'
      } else if (status == '2') {
        return 'orange'
      } else {
        return '#C9C9C9'
      }
    },
    statusName(status) {
      if (status == '2') {
        return this.lbl['pdpa_status_1']
      } else if (status == '1') {
        return this.lbl['pdpa_status_2']
      } else {
        return this.lbl['pdpa_status_3']
      }
    },
    dateformat(date) {
      if (date) {
        try {
          if (this.currentLocale == 'th') {
            const buddhistYear = moment.unix(date).year() + 543
            return moment
              .unix(date)
              .locale('th')
              .format(`DD MMM ${buddhistYear}`)
          } else {
            return moment.unix(date).format('DD MMM YYYY')
          }
        } catch {
          return ''
        }
      } else {
        return '-'
      }
    },
    view(data) {
      console.log(data)
      this.showPDPAModal = true
      this.PDPAdata = {
        type: this.$route.params.type,
        DisplayVersion: data.DisplayVersion,
      }
    },
    goback() {
      this.$router.push({
        name: 'Privacy',
        query: { type: this.$route.params.type },
      })
    },
  },
}
</script>

<style lang="scss">
@import 'style/PdpaUpload.scss';
.ant-tabs-nav .ant-tabs-tab-active {
  color: #f9a601 !important;
  font-weight: 500;
}
</style>
<style lang="scss" scoped>
.header-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  .button-back {
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid #424242;
    display: flex;
    align-items: center;

    .button-arrow-back {
      width: 20px;
      height: 20px;
    }
  }
  .title {
    color: #212121;
    font-size: 34px;
    font-weight: 400;
    line-height: 40px; /* 117.647% */
    letter-spacing: 0.25px;
  }
}
.history-wrapper {
  padding: 30px;
}
.action-icon {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: #fafafa;
  border-radius: 6px;
  color: #f9a601;
}
</style>
<style lang="scss">
.ant-modal-root .ant-modal-body {
  text-align: unset;
}
.ant-tabs-nav .ant-tabs-tab:hover {
  color: #f9a601;
}
</style>
